import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBucket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBucket"><Path d="M4.2467 8.24805L5.42094 17.6228C5.60894 19.1238 6.88499 20.25 8.39768 20.25H15.6023C17.115 20.25 18.3911 19.1238 18.5791 17.6229L19.7534 8.24805H4.2467Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M2.75 3.75H21.25V8.25H2.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBucket;
